<template>
  <div class="all-results-page-mobile min-h-[100vh]">
    <AllResultsWrapperMobile />
  </div>
</template>

<script>
import AllResultsWrapperMobile from '@/wrappers/mobile/AllResultsWrapperMobile.vue';

export default {
  name: 'AllResultsPageMobile',
  components: {
    AllResultsWrapperMobile,
  },
};
</script>
